import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Zap, Plus } from 'lucide-react';
import { API } from '@/App';

/**
 * Small credit balance pill for the DashboardShell sidebar.
 * Polls every 30 s so it stays fresh during uploads/analysis.
 */
export default function CreditBalance() {
  const [credits, setCredits] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetch = () => {
    axios
      .get(`${API}/credits/balance`)
      .then((r) => { setCredits(r.data.credits); setLoading(false); })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetch();
    const id = setInterval(fetch, 30000);
    return () => clearInterval(id);
  }, []);

  if (loading) return null;

  const low = credits !== null && credits < 10;

  return (
    <Link
      to="/billing"
      data-testid="credit-balance-sidebar"
      className={`flex items-center justify-between mx-1 mb-2 px-3 py-2 rounded-xl border transition-all group
        ${low
          ? 'bg-amber-50 border-amber-300 hover:border-amber-400 hover:bg-amber-100'
          : 'bg-gradient-to-r from-[#EFF6FF] to-[#ECFEFF] border-[#DBEAFE] hover:border-[#2563FF]/60 hover:from-[#DBEAFE] hover:to-[#CFFAFE]'
        }`}
    >
      <div className="flex items-center gap-2.5">
        <div className={`w-7 h-7 rounded-lg flex items-center justify-center shrink-0 ${low ? 'bg-amber-100' : 'bg-[#2563FF]/10'}`}>
          <Zap className={`w-4 h-4 ${low ? 'text-amber-500' : 'text-[#2563FF]'}`} />
        </div>
        <div>
          <p className={`font-heading text-base font-bold tabular-nums leading-none ${low ? 'text-amber-700' : 'text-[#0F172A]'}`}>
            {credits ?? 0}
          </p>
          <p className={`font-mono text-[9px] uppercase tracking-wider mt-0.5 ${low ? 'text-amber-500' : 'text-[#2563FF]'}`}>
            {low ? 'Low — top up' : 'credits'}
          </p>
        </div>
      </div>
      <div className={`w-6 h-6 rounded-md flex items-center justify-center transition-colors ${low ? 'bg-amber-100 group-hover:bg-amber-200' : 'bg-[#2563FF]/10 group-hover:bg-[#2563FF]/20'}`}>
        <Plus className={`w-3.5 h-3.5 ${low ? 'text-amber-500' : 'text-[#2563FF]'}`} />
      </div>
    </Link>
  );
}
